export function getRoleList(data) {
    let { getRoleListRequest, getRoleListError, getRoleListResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'get_role_list',
        this.createBundle('get_role_list', { data: data }, this.GET, getRoleListRequest, getRoleListResult, getRoleListError)
    )
}
